export const EMAIL_REGEX = '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$';
export const EXPIRED_CARD_REGEX = '^(0[1-9]|1[0-2])\/?([0-9]{2,4})$';

